import React, { FC } from 'react';
import SectionTitle from '@src/components/SectionTitle';
import { DropdownInput } from '@src/components/Select/DropdownInput';
import { CompanySizeProps } from './props';
import './styles.scss';

export const CompanySize: FC<CompanySizeProps> = ({ onChange, value, isInvalid, data }) => {
  return (
    <div className="company-size">
      <SectionTitle size="S" title="Company size*" />

      <DropdownInput
        isInvalid={isInvalid}
        onChange={value => {
          const selectedItem = data?.find(item => item.id === value?.value);

          if (selectedItem) {
            onChange(selectedItem);
          }
        }}
        options={data?.map(item => ({ label: item.name, value: item.id }))}
        placeholder="Please select"
        value={value ? { label: value.name, value: value.id } : undefined}
      />
    </div>
  );
};
